module.exports = __webpack_public_path__ + "static/media/banner-background.c02c27ee.png";